import { createStyles } from '@material-ui/core/styles';

export default () => createStyles({
  formControl: {
    minWidth: 250,
  },
  select: {
    color: '#ccc',
    fontSize: 14,
    '&:before': {
      borderBottom: 'none',
    },
    '&:after': {
      borderBottom: 'none',
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: 'none',
    },
  },
  icon: {
    color: '#666',
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    color: '#999696',
    fontSize: 14,
  },
  badge: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#DB5C0E',
    color: '#fff',
    borderRadius: '50%',
    width: 20,
    height: 20,
    fontSize: 11,
    fontWeight: 600,
  },
  menuPaper: {
    backgroundColor: 'white',
    color: 'black',
  },
  menuItem: {
    color: 'black',
    fontSize: 14,
    '&:hover': {
      backgroundColor: '#DB5C0E',
    },
    '&.Mui-selected': {
      backgroundColor: '#DB5C0E',
      color: '#fff',
    },
    '&.Mui-selected:hover': {
      backgroundColor: '#DB5C0E',
    },
  },
});
